export default __webpack_public_path__ + "static/media/ExpressBurgers.956e42fc.gif";